import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useAuth from "src/hooks/useAuth";
import PdfLinkActions from "src/components/PdfLinkActions";
import { getTitle, getReservationTitle } from "../utils";

const geHeaderTitle = (item, type) => {
  switch (type) {
    case "internalWorkOrder":
      return `Order # ${item.internalWorkOrderNumber}`;
    case "reservation":
      return getReservationTitle(item);
    default:
      return getTitle(item);
  }
};

export default function Header({ item, type = "order" }) {
  const { user } = useAuth();
  const resourceType = type === "internalWorkOrder" ? "internal_work_order_pdfs" : "inventory_request_pdfs";
  const { settings } = user.company;
  const wizardMode = settings?.wizard_mode;
  const simpleCheckoutForContractWarehouse = settings?.simple_checkout_for_contract_warehouse;
  const isExtendedCheckout = wizardMode || simpleCheckoutForContractWarehouse;
  const title = geHeaderTitle(item, type);

  return (
    <Box
      display="flex"
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      width="100%"
      gap={1}
      flexDirection={{
        xs: "column",
        sm: "row",
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography color="textPrimary" fontSize={18} fontWeight={500}>
          {title}
        </Typography>
        <PdfLinkActions resourceType={resourceType} resourceId={item?.id} />
      </Box>
      {!isExtendedCheckout && item.projectName && (
        <Typography color="textPrimary" fontSize={18} fontWeight={500}>
          {item.projectName}
        </Typography>
      )}
    </Box>
  );
}
